<template>
<div class="client-type">
  <label>{{ title }}</label>
  <div class="radio-group">
    <label v-for="item in options" :key="item.value" :class="['calculator-radio', inputDetails[inputName] == item.value ? 'active' : '']">
      <input type="radio" :name="inputName" :value="item.value" @change="changeHandler" v-model="inputDetails[inputName]" />
      {{ item.label }}
    </label>
  </div>
</div>
</template>

<script>
export default {
  name: "calculatorRadio",
  mounted: function() {
    this.inputDetails[this.inputName] = this.options[0].value;
  },
  props: ['title', 'inputName', 'options', 'inputDetails', 'changeHandler']
}
</script>

<style lang="scss">
.radio-group {
  padding: 10px 0;

  .calculator-radio {
    min-height: 20px;
    margin: 0 18px 0 0;
    padding-left: 30px;
    position: relative;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }

    @media (max-width: 480px) {
      margin: 0 0 10px;
      display: block;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &:before,
    &:after {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      border-radius: 50%;
      content: '';
    }

    &:before {
      width: 20px;
      height: 20px;
      display: block;
      left: 0;
      border: 2px solid #9598a2;
    }

    &:after {
      width: 12px;
      height: 12px;
      display: none;
      left: 4px;
      background: #9598a2;
    }

    &.active:after {
      display: block;
    }

    input {
      display: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/calculatorInputs/calculatorRadio.vue